import { keys } from './keys';

export const en = {
  [keys.share]: 'Share',
};
